<div class="col w100">
    <div class="w100 align-center space-between row">
        <h2>General Data Protection Regulation (GDPR)</h2>
    </div>
</div>
<div class="col w100">
    <div class="w100 align-center space-between row">
        <h3>Processing Activities</h3>
        <div class="row gap-16 align-center">
            <rr-btn
                iconStart="add"
                type="Primary"
                size="Medium"
                (click)="addActivity()"
                >Add Activity</rr-btn
            >
            <rr-btn
                iconStart="download"
                type="Secondary"
                size="Medium"
                (click)="exportActivities()"
                >Export Activities</rr-btn
            >
        </div>
    </div>
    <div class="w100">
        Processing Activites Tabel. (DSGVO Art. 30 - Verarbeitungsverzeichnis
        für Ideastream)
    </div>
    <app-processing-activities class="w100"></app-processing-activities>
</div>
